import { CardMenuHome } from "@core/components";
import { Container, Grid } from "@mui/material";
import { pages } from '@core/components/organisms/menu-items';

export function Beneficios() {
	return (
		<Container maxWidth="xl">
			<Grid sx={{ alignItems: 'center', justifyContent: 'center' }}>
				{pages.map((page) => {
					if (page.path.split('/').length > 3 && page.path.includes('beneficios')) {
						return (
							<CardMenuHome key={page.name} title={page.name} route={page.path} disabled={page.disabled} />
						);
					}
					return null;
				})}
			</Grid>
		</Container>
	)
}